import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../Button";
import { Colors } from "../../config/Constants";
import Modal from "../Modal";
import { useEffect, useState } from "react";
import ReportDownload from "./ReportDownload";
import DatePickerInput from "../Datepicker";
import Search from "../Search";
import Radio from "../Radio";
import Selectfield from "../Merchant/Selectfield";
import { getTransactionOptions } from "../../services/settingsService";
import { getFormattedTransaction } from "../../helper";
const downloadIcon = require("../../assets/images/download-icon.png");

type Props = {
  id: string;
  name: string;
  isTransactionEmpty: boolean;
  onSearchChange: (e: any) => void;
  onDateChange: (e: any) => void;
  query: string;
  date: Date | string;
  handleTransactionSelected: (e: any) => void;
  setFilterData: (e: boolean) => void;
  transactionSelected: string;
};

const ReportMerchantHeader = ({
  id,
  name,
  isTransactionEmpty,
  onSearchChange,
  query,
  onDateChange,
  date,
  handleTransactionSelected,
  setFilterData,
  transactionSelected,
}: Props) => {
  let navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [filter, setFilter] = useState(0);
  const [transactionOption, setTransactionOptions] = useState([]);

  useEffect(() => {
    fetchTransactionOptions();
  }, []);

  const fetchTransactionOptions = async () => {
    const transaction = await getTransactionOptions();
    const formattedData = getFormattedTransaction(
      transaction.data.data.transaction_types
    );
    setTransactionOptions(formattedData);
  };

  const convertDate = (inputFormat: string | number | Date) => {
    function pad(s: string | number) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join("-");
  };

  const handleFilterEntity = (checked: boolean, index: any) => {
    setFilter(index);
  };

  const handleSave = () => {
    setFilterModal(false);
    setFilterData(true);
  };

  return (
    <StyledReportHeader>
      <Back>
        <Link to="/admin/merchant">Back</Link>
      </Back>
      <StyledPageHeader>
        <div>
          <span>{name}-</span>
          <span>#{id}</span>
        </div>
        <FilterSection>
          <span>{convertDate(date.toString())}</span>
          <img
            src={require("../../assets/images/filter_icon.png")}
            alt="filter"
            onClick={() => {
              setFilterModal(!filterModal);
              setFilterData(false);
            }}
          />
          {filterModal && (
            <FilterModal>
              <FilterModalHeader>Date</FilterModalHeader>
              <Radio
                index={0}
                label="Today"
                selected={filter === 0}
                onChange={() => onDateChange(new Date())}
                name="filter_date"
              />
              <Radio
                index={1}
                label="Yesterday"
                selected={filter === 1}
                onChange={() =>
                  onDateChange(
                    new Date(new Date().setDate(new Date().getDate() - 1))
                  )
                }
                name="filter_date"
              />
              <Radio
                index={2}
                label="Enter Date"
                selected={filter === 2}
                onChange={handleFilterEntity}
                name="filter_date"
              />
              <DateContainer>
                <DatePickerInput
                  width={"85%"}
                  format="yyyy-mm-dd"
                  outlined={false}
                  //@ts-ignore
                  value={date}
                  ghostText="yyyy-mm-dd"
                  maxDate={new Date()}
                  disabled={filter !== 2}
                  onChange={onDateChange}
                />
              </DateContainer>
              <FilterModalHeader>Transaction Type</FilterModalHeader>
              <Selectfield
                data={transactionOption}
                name="test"
                required={false}
                helperText={""}
                value={transactionSelected}
                onChange={handleTransactionSelected}
              />
              <FilterActionWrapper>
                <Button
                  label="Save"
                  variant="filled"
                  color={Colors.solidRed}
                  size="medium"
                  onClick={handleSave}
                />
                <Button
                  label="Cancel"
                  color={Colors.white}
                  fontColor={Colors.solidRed}
                  size="medium"
                  outlineColor="transparent"
                  onClick={() => setFilterModal(false)}
                />
              </FilterActionWrapper>
            </FilterModal>
          )}
        </FilterSection>
      </StyledPageHeader>
      <ReportHeaderActions>
        <ActionWrapper>
          <Search
            placeholder="Search"
            onChange={onSearchChange}
            value={query}
          />
          <ButtonWrapperBack>
            {/* <Search placeholder="Search" onChange={onSearch} value={query} /> */}

            <Button
              label="Back"
              isRounded={true}
              variant=""
              size="small"
              onClick={() => navigate(-1)}
            />
          </ButtonWrapperBack>
        </ActionWrapper>
        <ButtonWrapperDownload>
          <Button
            label="Download"
            variant="filled"
            color={Colors.solidRed}
            size="medium"
            isRounded={true}
            onClick={() => setOpenModal(true)}
            endIcon={downloadIcon}
            disabled={isTransactionEmpty}
          />
        </ButtonWrapperDownload>
      </ReportHeaderActions>
      {openModal && (
        <Modal setOpenOrClose={setOpenModal} variant={"none"} width="21.2rem">
          <ReportDownload merchantID={id} setOpenOrClose={setOpenModal} />
        </Modal>
      )}
    </StyledReportHeader>
  );
};
const Back = styled.div`
  display: none;

  @media only screen and (max-width: 768px) {
    display: block;
  }

  padding: 0 1.5rem;
  padding-top: 1rem;
  > a {
    color: ${Colors.linkBlue};
  }
`;
const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  color: ${Colors.black};
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 1rem 1.5rem;
  }
`;

const ActionWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 2rem;
  @media only screen and (max-width: 768px) {
    width: 100%;
    margin-bottom: 1rem;
  }
`;

const FilterActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  @media only screen and (max-width: 768px) {
    width: 100%;
    margin-bottom: 1rem;
  }
`;

const StyledReportHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.25rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const ReportHeaderActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media only screen and (max-width: 768px) {
    padding: 1rem 1.5rem;
  }
`;

const ButtonWrapperBack = styled.div`
  width: 7.3rem;
  height: 2.8rem;
  margin-bottom: 1.25rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
const ButtonWrapperDownload = styled.div`
  width: 9.8rem;
  height: 2.8rem;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const FilterSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  margin-top: 1rem;
  font-size: 1.25rem;
`;

const DateContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-left: 1.75rem;
`;

const FilterModal = styled.div`
  background: #ffffff;
  border-radius: 1.25rem;
  position: absolute;
  width: 18rem;
  box-shadow: 0px 0px 5px rgba(166, 166, 166, 0.25);
  padding: 0.25rem 1.5rem;
  top: 2rem;
  display: flex;
  flex-direction: column;
  z-index: 999;
`;

const FilterModalHeader = styled.div`
  font-size: 1rem;
  margin: 1rem 0;
  margin-bottom: 0.5rem;
`;

export default ReportMerchantHeader;
